import {Component, OnInit} from '@angular/core';
import {Recipe} from "../../../dtos/recipe";
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {Ingredient} from "../../../dtos/ingredient";
import {RecipeService} from "../../../recipe-serivce.service";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {first, map} from "rxjs/operators";

@Component({
  selector: 'app-recipe-view',
  templateUrl: './recipe-view.component.html',
  styleUrls: ['./recipe-view.component.css']
})
export class RecipeViewComponent implements OnInit {

  public recipe$: Observable<Recipe>;
  private ingredients$: Observable<Ingredient[]>;
  private time$: Observable<number>;
  private _nrOfPeople: BehaviorSubject<number> = new BehaviorSubject(0);

  constructor(private route: ActivatedRoute, private recipeService: RecipeService, private auth: AngularFireAuth) {
  }

  ngOnInit() {
    this.route.params
      .pipe(
        first()
      )
      .subscribe(params => {
        this.recipe$ = this.recipeService.getRecipe(params["id"]);
        this.recipe$.pipe(first()).subscribe(recipe => this._nrOfPeople.next(recipe.nrOfPeople));
        this.ingredients$ = combineLatest([this.recipe$, this._nrOfPeople])
          .pipe(
            map(value => {
              const recipe: Recipe = value[0];
              const nrOfPeople: number = value[1];
              var ingredients: Ingredient[] = [];
              recipe.parts.forEach(part => {
                part.ingredients.forEach(ingredient => {
                  const copiedIngredient: Ingredient = new Ingredient(ingredient);
                  copiedIngredient.amount = copiedIngredient.amount / recipe.nrOfPeople * nrOfPeople;
                  ingredients.push(copiedIngredient);
                })
              });
              return ingredients;
            })
          );

        /*this.recipe$.pipe(
          map(v => {
            var ingredients: Ingredient[] = [];
            v.parts.forEach(part => {
              part.ingredients.forEach(ingredient => ingredients.push(ingredient));
            });
            return ingredients;
          })
        );*/
        this.time$ = this.recipe$.pipe(
          map(recipe => {
            var time: number = 0;
            recipe.parts.forEach(part => time += part.duration);
            return time;
          })
        )
      });
  }

  addPerson() {
    if (this._nrOfPeople.getValue() < 100) {
      this._nrOfPeople.next(this._nrOfPeople.getValue() + 1);
    }
  }

  removePerson() {
    if (this._nrOfPeople.getValue() > 1) {
      this._nrOfPeople.next(this._nrOfPeople.getValue() - 1);
    }
  }

  checkAuthor(): Observable<boolean> {
    return combineLatest([this.recipe$, this.auth.authState]).pipe(
      map(([recipe, user]) => user && (recipe.authorUid === user.uid || user.email === 'jdepypere@gmail.com'))
    );
  }

}
